import * as React from "react";
import moment from "moment";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

import {useSelector} from "react-redux";

import {statusOptions} from "@/utils/constants";
import {fetchPlayerRating} from "@/utils/playerRating";

import "./index.scss";

export default function RosterPlayerCard(props) {
	const {element, handleDelete} = props;

	const type =
		element?.goalkeeper !== undefined || element?.primaryRole || element?.player
			? "player"
			: "staff";
	const rosterElement =
		type === "player" ? element?.player || element : element?.staff || element;

	const currentStatus = statusOptions?.filter(
		(o) => o.value === rosterElement?.status,
	)?.[0];

	const seasonId = useSelector((state) => state?.season?.id);
	const [rating, setRating] = React.useState(null);

	React.useEffect(() => {
		let isMounted = true;

		const loadRating = async () => {
			if (type !== "player" || !rosterElement?.id || !seasonId) {
				return;
			}

			const value = await fetchPlayerRating(rosterElement.id, seasonId);
			if (isMounted) {
				setRating(
					value !== null && value !== undefined
						? Number(value.toFixed(2))
						: null,
				);
			}
		};

		loadRating();

		return () => {
			isMounted = false;
		};
	}, [type, rosterElement?.id, seasonId]);

	return (
		<div className="roster-player-card-container">
			{type === "player" && rating !== null && (
				<div className="rating-badge">
					{/* <span className="rating-label">Rtg</span> */}
					<span className="rating-value">{rating}</span>
				</div>
			)}
			<div className="roster-player-card-info">
				<div className="info-team">
					<div className="info-image">
						{!rosterElement?.prospect ? (
							<img
								src={require("@/assets/images/old/logo_player.png")}
								alt=""
							/>
						) : (
							""
						)}
					</div>
					{currentStatus?.value !== "Interno" ? (
						<div className="status">{currentStatus?.label}</div>
					) : null}
				</div>
				<div className="info-title">
					<div className="d-flex flex-column w-100">
						<div className="info-name">
							{rosterElement.firstName + " " + rosterElement.lastName}
						</div>
						{type === "player" && (
							<div className="info-text role-text">
								{rosterElement.goalkeeper
									? "Portiere"
									: rosterElement.primaryRole}
							</div>
						)}
						{type === "staff" && (
							<div className="info-text">{rosterElement.role}</div>
						)}
						{type === "staff" && (
							<div className="info-text">{"Area " + rosterElement.unit}</div>
						)}
						<div className="info-text dob-text">
							{rosterElement.dateOfBirth
								? moment(rosterElement.dateOfBirth).format(
										type === "player" ? "YYYY" : "DD/MM/YYYY",
									)
								: "---"}
						</div>
					</div>
				</div>
			</div>
			{handleDelete ? (
				<div className="action-container">
					<Button
						variant="outlined"
						color="error"
						size="small"
						onClick={() => handleDelete(element.attendanceId || element.id)}
					>
						<CloseIcon />
					</Button>
				</div>
			) : null}
		</div>
	);
}
